"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseApi = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var createApi = function createApi(baseUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    baseUrl: baseUrl
  };
  var apiInstance = arguments.length > 2 ? arguments[2] : undefined;
  return {
    "delete": apiInstance.createRequest(baseUrl, 'DELETE', options),
    get: apiInstance.createRequest(baseUrl, 'GET', options),
    post: apiInstance.createRequest(baseUrl, 'POST', options),
    put: apiInstance.createRequest(baseUrl, 'PUT', options)
  };
};

var BaseApi = function BaseApi(baseUrl) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    baseUrl: baseUrl
  };
  var apiInstance = arguments.length > 2 ? arguments[2] : undefined;
  (0, _classCallCheck2["default"])(this, BaseApi);
  (0, _defineProperty2["default"])(this, "baseUrl", void 0);
  (0, _defineProperty2["default"])(this, "options", void 0);
  (0, _defineProperty2["default"])(this, "api", void 0);
  this.baseUrl = baseUrl;
  this.options = options;
  this.api = createApi(this.baseUrl, options, apiInstance);
};

exports.BaseApi = BaseApi;
var _default = createApi;
exports["default"] = _default;
//# sourceMappingURL=createApi.js.map